export function getDomain(isDev = false) {
  const isLocal = window.location.origin === 'http://localhost:3000'
    || window.location.origin === 'http://127.0.0.1:3000';

  return isLocal
    ? `ancestry${isDev ? 'dev' : 'stage'}.com`
    : window.location.hostname.replace('www.', '').replace('petdna.', '');
}
